/**
 * Convert a given string to a number
 * @param value string
 * @returns number or null
 */
export default function (value?: string | number): number | undefined {
  // note: don't try !value because it'll ignore 0s
  if (value == null || value === '') {
    return undefined;
  }

  if (typeof value === 'number') return value;

  const number = Number(value);
  const returnValue = isNaN(number) || number == null || number === undefined ? undefined : number;

  // try to parse the string as a float
  if (returnValue === undefined) {
    const parsedValue = parseFloat(value);

    if (!isNaN(parsedValue) && isFinite(parsedValue)) {
      return parsedValue;
    }
  }

  return returnValue;
}
